{
  "aws_project_region": "us-east-1",
  "aws_mobile_analytics_app_id": "d3476b4552ff42568d293607f39897ef",
  "aws_mobile_analytics_app_region": "us-east-1",
  "Analytics": {
    "AWSPinpoint": {
      "appId": "d3476b4552ff42568d293607f39897ef",
      "region": "us-east-1"
    }
  },
  "aws_appsync_graphqlEndpoint": "https://xug4ifclpfdvbmagbnxj6tr6he.appsync-api.us-east-1.amazonaws.com/graphql",
  "aws_appsync_region": "us-east-1",
  "aws_appsync_authenticationType": "API_KEY",
  "aws_appsync_apiKey": "da2-c5petnw7hzdtfizwjym2bkezxe",
  "aws_cognito_identity_pool_id": "us-east-1:ef42afb7-a393-4bf5-bbe2-1621312bba62",
  "aws_cognito_region": "us-east-1",
  "oauth": {},
  "aws_cognito_username_attributes": [],
  "aws_cognito_social_providers": [],
  "aws_cognito_signup_attributes": [],
  "aws_cognito_mfa_types": [],
  "aws_cognito_password_protection_settings": {
    "passwordPolicyCharacters": []
  },
  "aws_cognito_verification_mechanisms": []
}